
import React from 'react';
import PropTypes from 'prop-types';
// import Button from 'common/components/elements/buttons/primary';
// import Text from 'common/designer-modules/modules/text';
// import cx from 'classnames';

const MMSPageHeader = ({
   isEditable,
   customSiteDesignerData,
   limits,
   type,
   onComponentChange,
   isMobile,
}) => {
   return (
      <div>
         page header
         ASAsASAs
      </div>

   );
}
MMSPageHeader.propTypes = {
   isEditable: PropTypes.bool,
   customSiteDesignerData: PropTypes.object,
   limits: PropTypes.object,
   type: PropTypes.string,
   onComponentChange: PropTypes.func,
   isMobile: PropTypes.bool,
};
MMSPageHeader.defaultProps = {
   isEditable: false,
}
export default MMSPageHeader;


